import { render, staticRenderFns } from "./OrderProductSupplierProductSelecet.vue?vue&type=template&id=8233e590&scoped=true&"
import script from "./OrderProductSupplierProductSelecet.vue?vue&type=script&lang=js&"
export * from "./OrderProductSupplierProductSelecet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8233e590",
  null
  
)

export default component.exports